module.exports = __webpack_public_path__ + "static/media/user.70b4cfdf.png";